export function isJSBlock(data) {
  return data && data.type === 'JSBlock';
}